import ReactDOM from "react-dom/client";
import { Modal} from "react-bootstrap";

export const openConfirmDialog = (
    title: string,
    message: string,
    confirmButtonText: string,
    cancleButtonText: string,
    onConfirm: () => void,
    iconName?: string,
) => {
    const modalContainer = document.createElement("div");
    document.body.appendChild(modalContainer);
    const root = ReactDOM.createRoot(modalContainer);

    const closeModal = () => {
        root.unmount();
        document.body.removeChild(modalContainer);
    };

    const onConfirmClick = () => {
        closeModal();
        onConfirm();
    };

    root.render(
        <Modal show={true} onHide={closeModal} centered className="custom-modal">
            <Modal.Header closeButton>
                <Modal.Title style={{ whiteSpace: "pre-line" }}>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="custom-track-model">
                    {/* <img src={logo} alt="logo" className="custom-modal-logo" /> */}
                    
                    <h4 className="custom-header-title" style={{ whiteSpace: "pre-line" }}>{message}</h4>

                    <div className="custom-modal-bottom" style={{ marginBottom: "30px" }}>
                        <button className="custom-secondary-button" onClick={onConfirmClick}>
                            {confirmButtonText}
                        </button>
                        <button className="custom-primary-button" onClick={closeModal}>
                            {cancleButtonText}
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};
